import { generateUUID } from "shared/lib/generateUUID"

import { priceResponseTransformer } from "./priceResponseTransformer"

export const productPriceResponseTransformer = async (response: Response) => {
  const transformedResponse = await priceResponseTransformer(response)
  return {
    ...transformedResponse,
    id: generateUUID()
  }
}
